import {get} from "@/context/context";
import {EventRepository} from "@/repositories/EventRepository";
import {RequestConfig} from "@/models/RequestConfig";
import {EventResponse} from "@/models/Event/EventResponse";
import {ListRequest} from "@/models/Event/ListRequest";
import {EventRequest} from "@/models/Event/EventRequest";

export class EventService {

    public eventRepository: EventRepository = get('eventRepository');

    public async getEvents(payload: ListRequest, config?:RequestConfig): Promise<EventResponse> {
        return await this.eventRepository.getEvents(payload, config);
    }

    public async createEvent(payload: EventRequest, config?:RequestConfig): Promise<any> {
        return await this.eventRepository.createEvent(payload, config);
    }
}
